import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RequestStatus } from "@app/constants";
import { IRequestFailed } from "@app/types";
import { IAddProduct, IProduct, IProductTypeSlice } from "./types";

const initialState: IProductTypeSlice = {
  product: {},
  addProduct: {},
  brands: {},
  category: {},
  findLocation: {},
  updateProductIdBy: {},
  newLocation: {},
  productFindById: {},
  deleteProductById: {},
  allCars: {},
  soldCar: {},
};

const slice = createSlice({
  name: "productTypes",
  initialState,
  reducers: {
    product(state, action: PayloadAction<IProduct>) {
      state.product.status = RequestStatus.RUNNING;
    },
    productSuccess(state, action) {
      state.product.status = RequestStatus.SUCCESS;
      state.product.data = action.payload;
    },
    productFailed(state, action: PayloadAction<IRequestFailed>) {
      state.product.status = RequestStatus.ERROR;
      state.product.error = action.payload;
    },
    allCars(state) {
      state.allCars.status = RequestStatus.RUNNING;
    },
    allCarsSuccess(state, action) {
      state.allCars.status = RequestStatus.SUCCESS;
      state.allCars.data = action.payload;
    },
    allCarsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.allCars.status = RequestStatus.ERROR;
      state.allCars.error = action.payload;
    },
    addProduct: (state, action: PayloadAction<{ formValues: IAddProduct }>) => {
      state.addProduct.status = RequestStatus.RUNNING;
    },
    addProductSuccess: (state, action: PayloadAction<any>) => {
      state.addProduct.status = RequestStatus.SUCCESS;
      state.addProduct.data = action.payload;
    },
    addProductFailed: (state, action: PayloadAction<any>) => {
      state.addProduct.status = RequestStatus.ERROR;
      state.addProduct.error = action.payload;
    },

    brands(state, action: PayloadAction) {
      state.brands.status = RequestStatus.RUNNING;
    },
    brandsSuccess(state, action) {
      state.brands.status = RequestStatus.SUCCESS;
      state.brands.data = action.payload;
    },
    brandsFailed(state, action: PayloadAction<any>) {
      state.brands.status = RequestStatus.ERROR;
      state.brands.error = action.payload;
    },
    category(state, action: PayloadAction) {
      state.category.status = RequestStatus.RUNNING;
    },
    categorySuccess(state, action) {
      state.category.status = RequestStatus.SUCCESS;
      state.category.data = action.payload;
    },
    categoryFailed(state, action: PayloadAction<any>) {
      state.category.status = RequestStatus.ERROR;
      state.category.error = action.payload;
    },
    findLocation(state, action: PayloadAction) {
      state.findLocation.status = RequestStatus.RUNNING;
    },
    findLocationSuccess(state, action) {
      state.findLocation.status = RequestStatus.SUCCESS;
      state.findLocation.data = action.payload;
    },
    findLocationFailed(state, action: PayloadAction<any>) {
      state.findLocation.status = RequestStatus.ERROR;
      state.findLocation.error = action.payload;
    },
    newLocationAdd(state, action: PayloadAction) {
      state.newLocation.status = RequestStatus.RUNNING;
    },
    newLocationAddSuccess(state, action) {
      state.newLocation.status = RequestStatus.SUCCESS;
      state.newLocation.data = action.payload;
    },
    newLocationAddFailed(state, action: PayloadAction<any>) {
      state.newLocation.status = RequestStatus.ERROR;
      state.newLocation.error = action.payload;
    },
    productFindById(state, action: PayloadAction<{ productId: number }>) {
      state.productFindById.status = RequestStatus.RUNNING;
    },
    productFindByIdSuccess(state, action) {
      state.productFindById.status = RequestStatus.SUCCESS;
      state.productFindById.data = action.payload;
    },
    productFindByIdFailed(state, action: PayloadAction<IRequestFailed>) {
      state.productFindById.status = RequestStatus.ERROR;
      state.productFindById.error = action.payload;
    },
    updateProductById(state, action: PayloadAction<any>) {
      state.updateProductIdBy.status = RequestStatus.RUNNING;
      state.updateProductIdBy.error = undefined;
    },
    updateProductByIdSuccess(state, action: PayloadAction<any>) {
      state.updateProductIdBy.status = RequestStatus.SUCCESS;
      state.updateProductIdBy.data = action.payload;
    },
    updateProductByIdFailed(state, action: PayloadAction<any>) {
      state.updateProductIdBy.status = RequestStatus.ERROR;
      state.updateProductIdBy.error = action.payload;
    },
    deleteProductById(state, action: PayloadAction<{ productId: number }>) {
      state.deleteProductById.status = RequestStatus.RUNNING;
    },
    deleteProductByIdSuccess(state, action) {
      state.deleteProductById.status = RequestStatus.SUCCESS;
      state.deleteProductById.data = action.payload;
    },
    deleteProductByIdFailed(state, action: PayloadAction<any>) {
      state.deleteProductById.status = RequestStatus.ERROR;
      state.deleteProductById.error = action.payload;
    },
    soldCar(state, action: PayloadAction<any>) {
      state.soldCar.status = RequestStatus.RUNNING;
    },
    soldCarSuccess(state, action) {
      state.soldCar.status = RequestStatus.SUCCESS;
      state.soldCar.data = action.payload;
    },
    soldCarFailed(state, action: PayloadAction<any>) {
      state.soldCar.status = RequestStatus.ERROR;
      state.soldCar.error = action.payload;
    },
  },
});

export const {
  product,
  brands,
  updateProductById,
  updateProductByIdSuccess,
  updateProductByIdFailed,
  deleteProductById,
  deleteProductByIdSuccess,
  deleteProductByIdFailed,
  productFindById,
  productFindByIdSuccess,
  productFindByIdFailed,
  category,
  categorySuccess,
  categoryFailed,
  brandsSuccess,
  brandsFailed,
  productSuccess,
  productFailed,
  addProduct,
  addProductSuccess,
  addProductFailed,
  findLocation,
  newLocationAdd,
  newLocationAddSuccess,
  newLocationAddFailed,
  findLocationSuccess,
  findLocationFailed,
  allCars,
  allCarsFailed,
  allCarsSuccess,
  soldCar,
  soldCarFailed,
  soldCarSuccess,
} = slice.actions;

export default slice.reducer;
